<template>
  <div class="index-trasferte-mobile" :style="{ height: (contenitoreHeight) + 'px'}">
    <!--<header-app :counterNuovi="counterNuovi"></header-app>-->
      <!-- <div class="titolo-app col-24 no-padding">
          <span class="titolo-bold hidden-xs">
            {{ $t($route.meta.appName).label }}
          </span>
      </div> -->

      <div class="contenitore col-24">
        <!-- <menu-app></menu-app> -->

        <div class="row row-custom trasferte-content">
          <keep-alive>
            <router-view name="mobile" class="col-24  no-padding" :style="{ minHeight: (contenitoreHeight) + 'px'}"
                       :contenitoreHeight="contenitoreHeight"></router-view>
          </keep-alive>
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    props: {
      contenitoreHeight: {
        type: Number
      }
    },
    name: 'IndexTrasferte',
    components: {/*HeaderApp*/},
    /*watch: {
      '$mq.resize': 'setContenitoreHeight'
    },*/
    data () {
      return {
        //contenitoreHeight: 0,
        //tableHeight: 0,
        //counterNuovi: 0
      }
    },
    mounted: function () {
      // this.$router.push({name: 'HomePage'})
      // this.setContenitoreHeight()
    },
    methods: {
      /*setContenitoreHeight: function () {
        console.log('size')
        this.contenitoreHeight = window.innerHeight - 140
        this.tableHeight = this.contenitoreHeight - 155
      }*/
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .index-trasferte-mobile {
    height: 100%;
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px; @color: @greenRiva);
      text-transform: uppercase;
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 50px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .icone {
      padding-top: 10px;
      .icona {
        text-align: center;
        .icona-menu {
          padding-left: 0px;
          padding-right: 3px;
          text-align: right;
          display: inline-block;
          vertical-align: middle;
        }
        .label-menu {
          .set-font(@size: 12px; @weight: bold);
          text-align: center;
          display: inline-block;
          vertical-align: middle;
        }
      }
      .icona:hover {
        cursor: pointer;
      }
    }
    .contenitore {
      padding-left: 10px;
      padding-right: 10px;
      .doc-title {
        height: 70px;
        // position: fixed;
    	  // background-color: white;
        // z-index: 100;

        .select-wrapper {
          position: relative;
          display: inline-block;
          &:after {
            content: '\0025BC';
            // font: normal normal normal 12px/1 FontAwesome;
            color: #cbb385;
            right: 65px;
            top: -3px;
            height: 26px;
            padding: 15px 0px 0px 8px;
            position: absolute;
            pointer-events: none;
          }
          select {
            width: 250px;
            padding-right: 24px;
            background-color: #fff;
            border-radius: 5px;
            border-color: #cbb385;
            font-family: Arial, ArialHebrew, sans-serif;
            font-size: 18px;
            text-align: center;
            color: #cbb385;
            margin: 3px;
            padding: 3px;
            -webkit-appearance: none;
            &:focus {
              outline: none;
            }
          }
        }

        /*select {
          height: 40px;
          //font-family: 'os-lightitalic';
          font-weight: bold;
          font-size: 16px;
          color: #cbb385;
          text-align: center;
          background-color: #ffffff;
         
        }*/
      }
      .trasferte-content {
        // padding-top: 50px;
      }
    }
    .box-left {
      border-right: 1px solid @greyLine;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TrasferteMobile/IndexTrasferteMobile.vue